/**
 * Клиент для сервера — это сессия входа (K-002): мини-апп — Bearer из /auth/telegram, PWA — cookie после входа
 * по телефону. `telegramId` в запросе сервер использует только как необязательную сверку с Telegram-сессией
 * (чужой — 403), а PWA-сессия его игнорирует. Поэтому шлём его, только когда он известен входу (мини-апп), и
 * не шлём совсем, когда его нет: `?telegramId=null`/`undefined` сервер отвергает как нечисловой (400).
 */

/** Telegram ID, если он есть: 0, null и undefined означают «нет» (у клиента PWA Telegram ID в профиле — 0). */
function knownTelegramId(telegramId?: number | null): string | null {
  return typeof telegramId === 'number' && Number.isFinite(telegramId) && telegramId > 0 ? String(telegramId) : null;
}

/** Путь с `telegramId` в query для сверки — только если он известен. */
export function withTelegramId(path: string, telegramId?: number | null): string {
  const id = knownTelegramId(telegramId);
  if (!id) return path;
  return `${path}${path.includes('?') ? '&' : '?'}telegramId=${id}`;
}

/** Поле `telegramId` для тела запроса — только если он известен (сервер ждёт строку). */
export function telegramIdField(telegramId?: number | null): { telegramId?: string } {
  const id = knownTelegramId(telegramId);
  return id ? { telegramId: id } : {};
}
